import {UploadedFilesSet} from './components/UploadedFilesSet';

export default UploadedFilesSet;
